import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { endTime: String };
  static targets = ["days", "hours", "minutes", "seconds"];

  connect() {
    this.update();
    this.timer = setInterval(() => this.update(), 1000);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  update() {
    const end = new Date(this.endTimeValue).getTime();
    const now = new Date().getTime();
    const distance = end - now;

    if (distance <= 0) {
      clearInterval(this.timer);
      this.daysTarget.textContent = "00";
      this.hoursTarget.textContent = "00";
      this.minutesTarget.textContent = "00";
      this.secondsTarget.textContent = "00";
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.daysTarget.textContent = this.format(days);
    this.hoursTarget.textContent = this.format(hours);
    this.minutesTarget.textContent = this.format(minutes);
    this.secondsTarget.textContent = this.format(seconds);
  }

  format(num) {
    return num.toString().padStart(2, "0");
  }
}
